import { useSelector } from "react-redux";
import { getCategoryFooterDescription } from "../../state/modules/category";
import { isFacetedNavPage } from "../../state/modules/category/selectors";
import CategoryFooterDescription from "./CategoryFooterDescription";

const CategoryFooterDescriptionContainer = () => {
  const isFaceted = useSelector(isFacetedNavPage);
  const description = useSelector(getCategoryFooterDescription);

  if (isFaceted) return null;

  return <CategoryFooterDescription description={description} />;
};

export default CategoryFooterDescriptionContainer;
